
import React from 'react';
import { ArrowRight, CheckCircle } from 'lucide-react';

const CtoServiceCallToAction = () => {
  const steps = [
    "Kostenloses 30-Minuten-Gespräch – wir hören uns deine Ziele an.",
    "Individuelles Angebot – Fahrplan + Fixpreis in 72 Stunden.",
    "IT-Budget sichern & Projekte anschieben – wir kümmern uns um die Umsetzung."
  ];

  return (
    <section className="py-16 bg-blue-700 text-white">
      <div className="container mx-auto px-4">
        <div className="max-w-4xl mx-auto text-center">
          <h2 className="text-3xl font-bold mb-6">Dein nächster Schritt</h2>
          
          <div className="space-y-4 mb-8 max-w-2xl mx-auto">
            {steps.map((step, index) => (
              <div key={index} className="flex items-center text-left">
                <CheckCircle className="h-6 w-6 text-orange-400 flex-shrink-0" />
                <span className="ml-3">{step}</span>
              </div>
            ))}
          </div>
          
          <div className="flex flex-col md:flex-row justify-center gap-4">
            <button className="bg-orange-500 hover:bg-orange-600 text-white font-bold py-3 px-6 rounded-lg transition duration-300 flex items-center justify-center">
              Jetzt Termin sichern <ArrowRight className="ml-2 h-5 w-5" />
            </button>
            <button className="bg-transparent border-2 border-white hover:bg-white hover:text-blue-700 text-white font-bold py-3 px-6 rounded-lg transition duration-300">
              Unverbindliches Angebot
            </button>
          </div>
          
          <p className="mt-10 text-lg italic">
            Externe IT-Leitung as a Service – klare Planung, saubere Zahlen, bessere Ergebnisse.
          </p>
        </div>
      </div>
    </section>
  );
};

export default CtoServiceCallToAction;
